import { datadogLogs } from "@datadog/browser-logs";
import { datadogRum } from "@datadog/browser-rum";

export const captureDatadogError = ({
  message,
  error,
  extraTags = {},
  extraContext = {},
}: {
  message: string;
  error: unknown;
  extraTags?: Record<string, unknown>;
  extraContext?: Record<string, unknown>;
}) => {
  if (typeof window === "undefined") {
    return;
  }

  const errorToLog = error instanceof Error ? error : new Error(message);

  // Log to console in development for debugging
  if (process.env.NODE_ENV === "development") {
    // eslint-disable-next-line no-console
    console.error("Datadog Error Capture:", {
      message,
      error: errorToLog,
      extraTags,
      extraContext,
    });
  }

  // Capture error in RUM (Real User Monitoring)
  if (datadogRum && datadogRum.addError) {
    datadogRum.addError(errorToLog, {
      crash_frontend: true,
      ...extraTags,
      ...extraContext,
      originalMessage: message,
      originalError: typeof error === "string" ? error : error instanceof Error ? error.message : "Unknown error",
    });
  }

  // Also log the error for detailed analysis
  if (datadogLogs && datadogLogs.logger) {
    datadogLogs.logger.error(message, {
      error: {
        kind: errorToLog.name,
        message: errorToLog.message,
        stack: errorToLog.stack,
      },
      ...extraTags,
      ...extraContext,
      originalError: error,
      originalMessage: message,
    });
  }

  return errorToLog;
};

export const captureDatadogFrontendCrash = (error: unknown) => {
  return captureDatadogError({
    message: `[Frontend Crash] ${error instanceof Error ? error.message : "Unknown error"}`,
    error,
    extraTags: {
      crash_frontend: true,
      error_type: "frontend_crash",
    },
  });
};
